import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { GetChatMessageListDto } from "../../../core/models/common/GetChatMessageListDto";
import { UserTagDto } from "../../../core/models/common/userTagDto";
import { DrawerModule } from "primeng/drawer";
import { CommonModule } from "@angular/common";
import { Select, SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { NameInitialsPipe } from "../../pipes/name-initials/name-initials.pipe";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-chatbox",
  templateUrl: "./chatbox.component.html",
  styleUrls: ["./chatbox.component.scss"],
  imports: [
    DrawerModule,
    CommonModule,
    SelectModule,
    ButtonModule,
    NameInitialsPipe,
    FormsModule,
    InputTextModule,
  ],
})
export class ChatboxComponent {
  @Input() messageList = [] as GetChatMessageListDto[];
  @Input() moduleId = "";
  @Input() moduleName = "";
  @Input() chatFirstCurrentDateIndex = 0;
  @Input() displayChat!: boolean;
  @Output() displayChange = new EventEmitter<boolean>();
  @Output() sendChatMessageEvent = new EventEmitter<string>();
  newMessage = "";
  showTagDropdown = false;
  @Input() users = [] as UserTagDto[];
  selectedTagId = "";
  saveMessage = "";
  isTextAreaDisabled = false;
  @ViewChild("tagDropdown") tagDropdown!: Select;

  onHide() {
    this.displayChange.emit(false);
  }

  formatMessage(message: string) {
    const regex = /@<[^,]+, ([^>]+)>/g;
    return message.replace(regex, (match, p1) => `<b>@${p1}</b>`);
    //return this.sanitizer.bypassSecurityTrustHtml(message);
  }

  sendMessage() {
    const mentionRegex = /@([\w.]+@[\w.]+\.\w+)|@(\w+)/g;
    this.saveMessage = this.newMessage.replace(
      mentionRegex,
      (match, email, mention) => {
        if (email) {
          return match;
        }
        const user = this.users.find(x => x.name === mention);
        return user ? `@<${user.userId}, ${user.name}>` : match;
      }
    );
    this.sendChatMessageEvent.emit(this.saveMessage);
    this.newMessage = "";
    this.saveMessage = "";
  }

  inputHandler(event: KeyboardEvent) {
    if (event.key === "@") {
      this.showTagDropdown = true;
      setTimeout(() => {
        this.tagDropdown.show();
      }, 0);
    } else {
      this.showTagDropdown = false;
    }
  }

  onTagSelectionChange(value: string) {
    this.isTextAreaDisabled = true;
    const user = this.users.find(x => x.userId === value) ?? ({} as UserTagDto);
    //this.saveMessage = this.replaceLastOccurrence(this.saveMessage, '@'+ user.userId, '@');
    this.newMessage = this.replaceLastOccurrence(
      this.newMessage,
      "@" + user.name,
      "@"
    );
    this.showTagDropdown = false;
    this.isTextAreaDisabled = false;
    this.selectedTagId = "";
  }

  replaceLastOccurrence(
    originalString: string,
    replaceString: string,
    searchString: string
  ): string {
    const lastIndex = originalString.lastIndexOf(searchString);
    if (lastIndex === -1) {
      return originalString;
    }
    const beforeLast = originalString.substring(0, lastIndex);
    const afterLast = originalString.substring(lastIndex + searchString.length);
    return beforeLast + replaceString + afterLast;
  }

  isTodayVisible(index: number) {
    const result = index === this.chatFirstCurrentDateIndex;
    return result;
  }

  isDateVisible(date: string) {
    const itemDate = new Date(date).toDateString();
    const todayDate = new Date().toDateString();
    const result = itemDate !== todayDate;
    return result;
  }
}
